export const PAGE_NOT_FOUND_ROUTE_DATA = {
  skipBreadcrumbs: true,
  titleKey: 'pageNotFound.title',
  messageKey: 'pageNotFound.message',
} as const;

export const CONTENT_DELETED_ROUTE_DATA = {
  skipBreadcrumbs: true,
  titleKey: 'contentDeleted.title',
  messageKey: 'contentDeleted.message',
} as const;
